// extracted by mini-css-extract-plugin
module.exports = {"weekCalendarGroup":"CalendarView_weekCalendarGroup__1N_EW","timezoneInfo":"CalendarView_timezoneInfo__1hcyo"};